exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Toastify__toast-container {\n    width: 70%;\n}\n.Toastify__toast-container--top-center {\n    top: auto;\n}\n.Toastify__toast {\n    color: #FFFFFF;\n    background-color: #db5305;\n    border-radius: 4px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/styles/overrideReactToastify.css
// module id = 9828
// module chunks = 23